/**
 * Reglas de UI para gate de mantenimiento en sesiones autenticadas (CAPDT-261).
 */

export function isMaintenanceAdminRole(role: string | null | undefined): boolean {
  if (!role) return false
  return role.toLowerCase().trim() === 'admin'
}

export function shouldShowAuthenticatedMaintenanceGate(input: {
  isMaintenanceActive: boolean
  platformStatusLoading: boolean
  userRole: string | null
  impersonationActive: boolean
}): boolean {
  if (input.platformStatusLoading || !input.isMaintenanceActive) return false
  if (input.impersonationActive) return false
  if (isMaintenanceAdminRole(input.userRole)) return false
  return true
}
